import React, { ComponentType } from 'react';
import { Route } from 'react-router';
import { Footer } from '../Footer';

export interface FooterRouteProps {
  Component: ComponentType;
  path?: string;
  exact?: boolean;
  default?: boolean;
  margin?: boolean;
}

const FooterRoute: React.FC<FooterRouteProps> = ({ Component, margin, ...rest }) => (
  <Route {...rest}>
    <Component {...rest} />
    <Footer margin={margin} />
  </Route>
);

export default FooterRoute;
